namespace TabAurous.OMS {
    export interface DesignExcelForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class DesignExcelForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.DesignExcel';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DesignExcelForm.init)  {
                DesignExcelForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(DesignExcelForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
